import React from 'react';

import { TextWithCopy } from './TextWithCopy';

/** Characters kept at each end when a UUID is shortened, matching the legacy Fluent component. */
const VISIBLE_CHARS = 6;
const ELLIPSIS = '…';

/**
 * Shortens a UUID from the middle. CSS truncation can only cut the tail, which is the half that tells apart ids
 * sharing a prefix — and in a narrow table column it can cut so much that nothing identifying is left. Keeping both
 * ends keeps it identifiable at a fixed 13 characters; the full value stays available through the tooltip and the
 * copy button.
 */
export const truncateUuid = (uuid: string): string =>
  uuid.length > VISIBLE_CHARS * 2 + ELLIPSIS.length
    ? `${uuid.slice(0, VISIBLE_CHARS)}${ELLIPSIS}${uuid.slice(-VISIBLE_CHARS)}`
    : uuid;

export interface UuidTruncatedProps {
  uuid: string;
  className?: string;
}

export const UuidTruncated = React.memo(({ uuid, className }: UuidTruncatedProps) => {
  if (!uuid) return null;
  return <TextWithCopy text={uuid} displayText={truncateUuid(uuid)} className={className} />;
});
UuidTruncated.displayName = 'UuidTruncated';
